
// import React, { useState, useEffect } from "react";
// import { Menu, Phone, X } from "lucide-react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../assets/logo.png";
// import "../Styles/GoogleTranslate.css"; // Make sure this path is correct

// const Navbar = () => {
//   const location = useLocation();
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   const nav_links = [
//     { name: "Home", link: "/" },
//     { name: "About", link: "/about" },
//     { name: "Executive Panel", link: "/panel" },
//     { name: "Tracks", link: "/tracks" },
//     { name: "Orators", link: "/orators" },
//     { name: "Schedule", link: "/event_schedule" },
//     { name: "Venue", link: "/venue" },
//     { name: "Event Partners", link: "/event_partners" },
//     { name: "Contact", link: "/contact" },
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       requestAnimationFrame(() => {
//         setScrolled(window.scrollY > 80);
//       });
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Initialize Google Translate widget
//   useEffect(() => {
//     // Check if the Google Translate script has loaded and the global function is available
//     if (
//       window.google &&
//       window.google.translate &&
//       typeof window.googleTranslateElementInit === "function"
//     ) {
//       window.googleTranslateElementInit();
//     } else {
//       // If not, set up a listener for when the script loads (important for client-side rendering)
//       window.addEventListener("load", () => {
//         if (
//           window.google &&
//           window.google.translate &&
//           typeof window.googleTranslateElementInit === "function"
//         ) {
//           window.googleTranslateElementInit();
//         }
//       });
//     }
//   }, []);

//   return (
//     <header className="bg-white sticky top-0 z-50 w-full shadow-sm">
//       <div className="flex items-center justify-between px-4 py-2 md:py-2 transition-all duration-300">
//         {/* Logo */}
//         <div
//           className={`transition-all duration-300 ${
//             scrolled ? "h-20" : "h-20"
//           }`}
//         >
//           <img
//             src={logo}
//             alt="Helix Conferences"
//             className={`rounded-full object-cover transition-all duration-300`}
//             loading="lazy"
//             style={{
//               height: scrolled ? "5rem" : "8rem",
//               width: scrolled ? "6rem" : "8rem",
//               marginTop: scrolled ? "0rem" : "1rem",
//               border: scrolled ? "none" : "2px solid black",
//               backgroundColor: scrolled ? "transparent" : "white",
//               padding: scrolled ? "0px" : "4px",
//             }}
//           />
//         </div>

//         {/* Desktop Navigation */}
//         <nav
//           className={`hidden md:flex items-center text-md ${
//             scrolled ? "gap-8 ml-4" : "gap-6 ml-8"
//           }`}
//         >
//           {nav_links.map((item, index) => (
//             <Link
//               key={index}
//               to={item.link}
//               className={`hover-underline-animation text-gray-700 hover:text-accent transition ${
//                 location.pathname === item.link
//                   ? "border-slate-700"
//                   : "border-transparent"
//               }`}
//               style={{
//                 marginRight: scrolled ? "0px" : "4px",
//               }}
//             >
//               {item.name}
//             </Link>
//           ))}
//         </nav>

//         {/* Desktop Register + Phone + Google Translate */}
//         <div className="hidden md:flex items-center gap-5">
//           <div className="flex items-center gap-1">
//             <Link
//               to="https://helixconferences.com/register.php?type=webinar"
//               className="py-2 px-8 text-accent rounded-full bg-accent text-white transition"
//               target="blank"
//             >
//               Register
//             </Link>
//             <div className="flex flex-col items-start justify-center"> {/* Changed justify-start */}
//               {/* <div className="flex items-center text-md text-one gap-1">
//                 <Phone className="ml-4" size={20} />
//                 <a href="tel:+17576567778">+1757 656 7778</a>
//               </div> */}
//               {/* Google Translate Widget - Desktop */}
//               <div
//                 id="google_translate_element"
//                 className="font-sm d-none d-md-block text-one" // Removed flex items-end justify-start from here
//               ></div>
//             </div>

//           </div>
//         </div>

//         {/* Mobile Menu Button */}
//         <div className="md:hidden ml-auto z-300">
//           <button onClick={() => setIsOpen(!isOpen)}>
//             {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Navigation */}
//       {isOpen && (
//         <div className="md:hidden bg-white px-4 pb-4 space-y-4 shadow-md">
//           {nav_links.map((item, index) => (
//             <Link
//               key={index}
//               to={item.link}
//               className="block text-sm text-gray-800 hover:text-accent transition"
//               onClick={() => setIsOpen(false)}
//             >
//               {item.name}
//             </Link>
//           ))}
//           <div className="flex flex-col items-center gap-2">
//             {/* Google Translate Widget - Mobile */}
//             <div
//               id="google_translate_element"
//               className="d-block mt-2"
//             ></div>
//             <Link
//               to="https://helixconferences.com/register.php?type=webinar"
//               className="block w-full border border-accent text-center py-2 rounded-full text-accent hover:bg-accent hover:text-white transition"
//             >
//               Register
//             </Link>
//             <div className="flex items-center text-one gap-1">
//               <Phone />
//               <p>+1757 656 7778</p>
//             </div>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { Menu, Phone, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import "../Styles/GoogleTranslate.css";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const nav_links = [
    { name: "Home", link: "/" },
    { name: "About", link: "/about-public-health-conclave/" },
    { name: "Executive Panel", link: "/executive-panel-members/" },
    { name: "Tracks", link: "/public-health-conference-tracks/" },
    { name: "Orators", link: "/world-public-health-summit-orators" },
    { name: "Schedule", link: "/public-health-event-schedule" },
    { name: "Venue", link: "/venue" },
    { name: "Event Partners", link: "/event_partners" },
    { name: "Contact", link: "/contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > 80);
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // useEffect(() => {
  //   if (
  //     window.google &&
  //     window.google.translate &&
  //     typeof window.googleTranslateElementInit === "function"
  //   ) {
  //     window.googleTranslateElementInit();
  //   } else {
  //     window.addEventListener("load", () => {
  //       if (
  //         window.google &&
  //         window.google.translate &&
  //         typeof window.googleTranslateElementInit === "function"
  //       ) {
  //         window.googleTranslateElementInit();
  //       }
  //     });
  //   }
  // }, []);

  return (
    <header className="bg-white sticky top-0 z-50 w-full shadow-sm">
      <div className="flex items-center justify-evenly px-2 py-2 md:py-2 transition-all duration-300">
        {/* Logo */}
        <div
          className={`transition-all duration-300 ${
            scrolled ? "h-20" : "h-20"
          }`}
        >
          <img
            src={logo}
            alt="Public Health Logo"
            className="rounded-full object-cover transition-all duration-300"
            loading="lazy"
            style={{
              height:
                isOpen && window.innerWidth < 1024
                  ? "5rem" // smaller when burger menu is open
                  : scrolled
                  ? "5rem"
                  : "8rem",
              width:
                isOpen && window.innerWidth < 1024
                  ? "6rem"
                  : scrolled
                  ? "6rem"
                  : "8rem",
              marginTop:
                isOpen && window.innerWidth < 1024
                  ? "0.5rem"
                  : scrolled
                  ? "0rem"
                  : "1rem",
              border:
                isOpen && window.innerWidth < 1024
                  ? "none"
                  : scrolled
                  ? "none"
                  : "2px solid black",
              backgroundColor:
                isOpen && window.innerWidth < 1024
                  ? "transparent"
                  : scrolled
                  ? "transparent"
                  : "white",
              padding:
                isOpen && window.innerWidth < 1024
                  ? "0px"
                  : scrolled
                  ? "0px"
                  : "4px",
            }}
          />
        </div>

        {/* Desktop Navigation - large screens only */}
        <nav
          className={`hidden lg:flex justify-between items-center text-lg font-bold-100 ${
            scrolled ? "gap-8 ml-4" : "gap-6 ml-0"
          }`}
        >
          {nav_links.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className={`hover-underline-animation text-gray-700 hover:text-accent transition ${
                location.pathname === item.link
                  ? "border-slate-700"
                  : "border-transparent"
              }`}
              style={{
                marginRight: scrolled ? "0px" : "4px",
              }}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Desktop Right Section - large screens only */}
        <div className="hidden lg:flex items-center gap-5">
          <div className="flex items-center gap-1">
            <Link
              to="https://helixconferences.com/register.php?type=conference"
              className="py-2 px-8 text-accent rounded-full bg-accent text-white transition"
              target="blank"
            >
              Register
            </Link>
            <div className="flex flex-col items-start justify-center">
              <div
                id="google_translate_element"
                className="font-sm text-one"
              ></div>
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Burger Menu Button */}
        <div className="lg:hidden ml-auto z-300">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile/Tablet Navigation Drawer */}
      {isOpen && (
        <div className="lg:hidden bg-white px-4 pb-4 space-y-4 shadow-md">
          {nav_links.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="block text-sm text-gray-800 hover:text-accent transition"
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </Link>
          ))}
          <div className="flex flex-col items-center gap-2">
            <div id="google_translate_element" className="mt-2"></div>
            <Link
              to="https://helixconferences.com/register.php?type=conference"
              className="block w-full border border-accent text-center py-2 rounded-full text-accent hover:bg-accent hover:text-white transition"
            >
              Register
            </Link>
            <div
              id="google_translate_element"
              className="font-sm text-one"
            ></div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;